import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '@core/payments/services/payment.service';
import { TransactionService } from '@shared/services/transaction.service';
import { ThemeService } from '@shared/services/theme.service';
import { jwtDecode } from 'jwt-decode';
import { PaymentPageComponent } from '../payment-page/payment-page.component';
import { LoaderService } from '@shared/services/loader.service';
import { LabelService } from '@core/payments/services/label.service';

@Component({
    selector: 'app-continue-page',
    templateUrl: './continue-page.component.html',
    styleUrls: ['./continue-page.component.css'],
    standalone: false
})
export class ContinuePageComponent implements OnInit {
  public errorproceso: Boolean = false;
  jwtCardinal: string = '';
  binCard: string = '';
  cardExpirationDate: string = '';
  formattedMaskedValue: string = '';
  backToCardForm: boolean = false;
  public phoneNumber: string | null = '';
  public isDarkMode: boolean = false;
  public channel: number = 0;
  public currentLanguage: 'es' | 'en' = 'es';
  public arraylabels: any = {};


  constructor(
    private _loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private _transactionService: TransactionService,
    private route: ActivatedRoute,
    private router: Router,
    private LabelService: LabelService,
    public _paymentService: PaymentService,
    private paymentpage: PaymentPageComponent,
    private themeService: ThemeService
  ) {
    this.isDarkMode = this.themeService.isDarkMode();
  }

  ngOnInit(): void {
    this.phoneNumber = localStorage.getItem('phoneNumber');
    this.initializeLanguage();

    // Cargar las etiquetas desde el localStorage
    this.arraylabels = localStorage.getItem('paymentScreenData');
    this.arraylabels = JSON.parse(this.arraylabels);
  }

  private initializeLanguage(): void {
    const storedChannel = localStorage.getItem('channel');
    if (storedChannel) {
      this.channel = parseInt(storedChannel, 10);
    }
  }


  formatMaskedValue(maskedValue: string, bin: string): string {
    const firstFourBin = bin.slice(0, 4); // Obtener los primeros 4 dígitos del bin
    const lastDigits = maskedValue.slice(-4); // Obtener los últimos 4 dígitos del maskedValue
    const maskedSection = '*'.repeat(maskedValue.length - 8); // Crear los asteriscos para la sección enmascarada

    return `${firstFourBin}${maskedSection}${lastDigits}`;
  }

  async pinpage() {
    try {
      if (this._paymentService.uploadcard === true) {
        this._paymentService.bodyrequestcard.emailAddress =
          this._paymentService.emailFromDom;
        this._paymentService.bodyrequestcard.afiliartarjeta = false;
        this._paymentService.bodyrequestcard.uploadCard = true;
        this._paymentService.afilcard = false;
      }

      this.paymentpage.transactionIsFinalized = true;

      const transactionSummary = await this.paymentpage.sendPaymentForm(
        this._paymentService.bodyrequestcard
      );
      window.parent.postMessage(transactionSummary, '*');

      if (transactionSummary.resultCode === 'SUCCESS') {
        if (transactionSummary.result.status === 'ERROR') {
          transactionSummary.result.status = 'DECLINED';
        }
        this._paymentService.requestpayment = transactionSummary;
        const isApproved = transactionSummary.result.status === 'APPROVED';
        const isNational = this._paymentService.getIsNational() === true;
        const hasValidResultCode =
          (transactionSummary.result?.EnrollAutomaticPaymentResult
            ?.resultCode ?? 'ERROR') !== 'ERROR';
        const isAfilCard = this._paymentService.afilcard;

        if (transactionSummary.result.status === 'PENDING_CAPTURE') {
          this._loaderService.hideLoading();
          this.router.navigate(['/payment/', 'store-confirmation'], { replaceUrl: true });
          return;
        }

        if (isApproved && isNational) {
          if (hasValidResultCode && isAfilCard) {
            this.router.navigate(['/pinpage']);
            return;
          } else if (this._paymentService.uploadcard === true) {
            this._paymentService.bodyrequestcard.tokenData =
              transactionSummary.result.updateCardResult.tokenData;
            this.changeCard();
            return;
          }
        }
        this._loaderService.hideLoading();
        this.router.navigate(['/confirmationpayment'], { replaceUrl: true });
      } else {
        this._loaderService.hideLoading();
        this.errorproceso = true;
        setTimeout(() => {
          this.errorproceso = false;
        }, 5000);
      }
    } catch (error) {
      this._loaderService.hideLoading();
      console.log(error);

      this.router.navigate(['/confirmationpayment'], { replaceUrl: true });
    }
  }

  private async changeCard() {
    const resultUbindCard = await this.unbindCard(
      this._paymentService.bodyrequestcard
    );
    if (resultUbindCard.resultCode === 'SUCCESS') {
      this._paymentService.finishpin = false;
      this.router.navigate(['/confirmationDAM']);
    } else {
      this._loaderService.hideLoading();
      this.errorproceso = true;
      setTimeout(() => {
        this.errorproceso = false;
      }, 5000);
      this._paymentService.finishpin = true;
      this.router.navigate(['/confirmationDAM']);
    }
  }

  async updateCardService() {
    try {
      const resultUbindCard = await this.unbindCard(
        this._paymentService.bodyrequestcard
      );
      if (resultUbindCard.resultCode === 'SUCCESS') {
        this._paymentService.finishpin = false;
        this.router.navigate(['/confirmationDAM']);
      } else {
        this._paymentService.finishpin = true;
        this.router.navigate(['/confirmationDAM']);
      }
    } catch (error) {
      this._paymentService.finishpin = true;
      this.router.navigate(['/confirmationDAM']);
    }
  }

  unbindCard(bodyRequest?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const extractedData = {
        rfc: this._paymentService.numberphone,
        toke_numero: this._paymentService.tokeNumero,
        transientToken: bodyRequest.transientToken,
        captureContext: bodyRequest.captureContext,
        tokenData: this._paymentService.bodyrequestcard.tokenData,
      };

      this._paymentService.unbindCardPayment(extractedData).subscribe(
        (transactionSummary) => {
          const { resultCode, result } = transactionSummary;
          if (transactionSummary.errorCode) {
            this._paymentService.setIsNational(false);
          }
          resolve(transactionSummary);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  goBack() {
    this._paymentService.numbermodule = 0;
  }

  // Método para obtener las etiquetas según la clave, idioma y canal actuales
  // Si se envia el canal como 7 se obtienen las etiquetas en español e ingles
  public getLabel(key: string): string {
    // Llama al servicio para obtener los textos
    return this.LabelService.getLabel(key, this.currentLanguage, this.channel);
  } 
}
